var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18H2.24999C1.86999 18 1.54999 17.72 1.50999 17.34L-1.16262e-05 5.34C-0.0300116 5.13 0.0399884 4.91 0.179988 4.75C0.319988 4.59 0.529988 4.5 0.739988 4.5H17.25C17.47 4.5 17.67 4.59 17.81 4.75C17.95 4.91 18.02 5.13 17.99 5.34L16.49 17.34C16.44 17.72 16.12 18 15.75 18ZM2.90999 16.5H15.09L16.4 6H1.59999L2.90999 16.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.25H13.5V3.75C13.5 2.35 12.92 0 9 0C5.08 0 4.5 2.35 4.5 3.75V8.25H3.75C3.34 8.25 3 8.59 3 9C3 9.41 3.34 9.75 3.75 9.75H6.75C7.16 9.75 7.5 9.41 7.5 9C7.5 8.59 7.16 8.25 6.75 8.25H6V3.75C6 2.78 6.31 1.5 9 1.5C11.69 1.5 12 2.78 12 3.75V8.25H11.25C10.84 8.25 10.5 8.59 10.5 9C10.5 9.41 10.84 9.75 11.25 9.75H14.25C14.66 9.75 15 9.41 15 9C15 8.59 14.66 8.25 14.25 8.25Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.efe48e0221bbfdb87769f24cf29188e5.svg";
export { ForwardRef as ReactComponent };